import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import LayoutProvider from '../LayoutContext';

import CartFlyout from '../../components/CartFlyout';
import Footer from '../Footer';
import Header from '../Header';
import UKModal from '../../components/UKModal';
import StudioFinderForm from '../../components/Forms/StudioFinderFormV2';
import AlertModal from '../../components/AlertModal';

import { initAlgoliaInsights, getQueryParam } from '../../components/SearchAlgolia/helpers/algolia-functions';

const ns = `layout-default`;

const DefaultLayout = ({ children, location }) => {
	const [isBlank, setBlank] = useState(true);

	useEffect(() => {
		function gtag() { window.dataLayer.push(arguments); } // eslint-disable-line
		window.gtag = gtag;
	}, []); // eslint-disable-line

	//	Global, one-time Algolia Insights init
	// (needed for search analytics and conversion attribution).
	useEffect(() => {
		initAlgoliaInsights();
	}, []); // eslint-disable-line

	useEffect(() => {
		if (!(location.pathname === '/account/logout/' || location.pathname === '/account/signup/' || location.pathname === '/account/login/')) {
			setBlank(() => false);
		}
	}, [location.pathname]);

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--blank`]: isBlank,
	});

	return (
		<LayoutProvider>
			<div className={rootClassnames}>
				<Header pathname={location.pathname} searchQuery={getQueryParam(location)} />
				<main>
					{children}
				</main>
				<Footer />
			</div>
			<CartFlyout />
			<UKModal />
			<StudioFinderForm />
			<AlertModal positionRight={!location?.pathname.includes('account')} />
		</LayoutProvider>
	);
};

export default DefaultLayout;
